export default {
  inconsistenciasEnum: {
    MERCADORIA_BLOQUEADA: 1,
    VALOR_ACIMA_LIMITE: 2,
    VALOR_PREMIO_ACIMA_LIMITE: 3,
    TAXA_SINISTRALIDADE_ACIMA_LIMITE: 4,
    PROPOSTA_EXPIRADA: 5
  }
}


// WEBPACK FOOTER //
// ./src/helpers/inconsistencias.js